module.exports = __webpack_public_path__ + "img/article-placeholder.63e08102.jpg";